import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeNewComponent} from './home-new/home-new.component';
import {WeatherComponent} from './weather/weather.component';
import {ExpertsComponent} from './experts/experts.component';
import {MarketPricesComponent} from './market-prices/market-prices.component';
import {MarketBagComponent} from './market-bag/market-bag.component';
import {SignupComponent} from './users/signup/signup.component';
import {SigninComponent} from './users/signin/signin.component';
import {RegisterBusinessComponent} from './users/register-business/';
import {MyAccountComponent} from './users/my-account/my-account.component';
import {ForgetPasswordComponent} from './users/forget-password/forget-password.component';
import {ResetPasswordComponent} from './users/reset-password/reset-password.component';
import {FpRequrestSentComponent} from './users/fp-requrest-sent/fp-requrest-sent.component';
import {ResetPasswordCompleteComponent} from './users/reset-password-complete/reset-password-complete.component';
import {ShippingAddressComponent} from './users/shipping-address/shipping-address.component';
import {UserEditFormComponent} from './users/user-edit-form/user-edit-form.component';
import {UserProfilePictureComponent} from './users/user-profile-picture/user-profile-picture.component';
import {FilterPageGuard} from './_guards/filter-page.guard';
import {AuthGuard} from './_guards/auth.guard';
import {SellerProfileIncompleteGuard} from './_guards/seller-profile-incomplete.guard';
import {VerifiedSellerGuard} from './_guards/verified-seller.guard';
import {OfferComponent} from './offer/offer.component';
import {OfferFormComponent} from './offer-form/offer-form.component';
import {OfferViewComponent} from './offer-view/offer-view.component';
import {OfferEditFormComponent} from './user-offer/offer-edit-form/offer-edit-form.component';
import { ProductsListComponent } from './products/products-list/products-list.component';
import { CategoryProductsComponent } from './products/category-products/category-products.component';
import {SingleProductComponent} from './products/single-product/single-product.component';
import {CartComponent} from './cart/cart.component';
import {UserChangePasswordComponent} from './users/user-change-password/user-change-password.component';
import {CheckoutComponent} from './checkout/checkout.component';
import { WishlistComponent } from './wishlists/wishlist/wishlist.component';
import { BlogComponent } from './blog/blog/blog.component';
import { BlogPostComponent } from './blog/blog-post/blog-post.component';
import { AddBlogPostComponent } from './blog/add-blog-post/add-blog-post.component';
import { PageComponent } from './page/page.component';
import { ContactComponent } from './contact/contact.component';
import { TeamComponent } from './team/team.component';
import { PaymentReturnComponent } from './payment-return/payment-return.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { OrdersListComponent } from './orders/orders-list/orders-list.component';
import { OrderComponent } from './orders/order/order.component';
import {PlaceCommandComponent} from './users/place-command/place-command.component';
import {SalesComponent} from './sales/sales.component';
import {ActivationComponent} from './users/activation/activation.component';
import {SignupConfirmationComponent} from './users/signup-confirmation/signup-confirmation.component';
import { CareerComponent } from './career/career.component';
import { SubscriptionComponent } from './users/subscription/subscription.component';
import { BillingHistoryComponent } from './users/billing-history/billing-history.component';
import { ShippingMeansComponent } from './users/shipping-means/shipping-means.component';
import { ShippingOptionDetailComponent } from './users/shipping-means/shipping-option-detail/shipping-option-detail.component';
import { SalesListComponent } from './users/sales-list/sales-list.component';
import { SaleDetailComponent } from './users/sale-detail/sale-detail.component';
import { TestimonialsPageComponent } from './testimonials/testimonials-page/testimonials-page.component';
import { SellerProductsComponent } from './products/seller-products/seller-products.component';
import { PartnersPageComponent } from './partners/partners-page/partners-page.component';
import { DeliveryComponent } from './delivery/delivery.component';
import { DeliveryRequestsComponent } from './users/delivery-requests/delivery-requests.component';
import { DeliveryRequestDetailComponent } from './users/delivery-requests/delivery-request-detail/delivery-request-detail.component';


const routes: Routes = [
    {path: 'signup', component: SignupComponent},
    {path: 'signup/confirmation', component: SignupConfirmationComponent},
    {path: 'signin', component: SigninComponent},
    {path: 'forget-password', component: ForgetPasswordComponent},
    {path: 'forget-password/request-sent', component: FpRequrestSentComponent},
    {path: 'password-reset/:token', component: ResetPasswordComponent},
    {path: 'activate/:token', component: ActivationComponent},
    {path: 'password-reset-complete', component: ResetPasswordCompleteComponent},
    {path: 'register-business', component: RegisterBusinessComponent},
    {
        path: 'seller-setup',
        canActivate: [AuthGuard],
        loadChildren: () => import('./seller-setup/seller-setup.module').then(m => m.SellerSetupModule)
    },
    {
        path: 'carrier-setup',
        canActivate: [AuthGuard],
        loadChildren: () => import('./carrier-setup/carrier-setup.module').then(m => m.CarrierSetupModule)
    },
    {
        path: 'user',
        canActivate: [AuthGuard, FilterPageGuard],
        children: [
            {
                path: 'dashboard',
                component: MyAccountComponent,
                title: 'My eFarm',
                canActivate: [SellerProfileIncompleteGuard]
            },
            {path: 'place-your-command', component: PlaceCommandComponent,  title: 'Place command'},
            {
                path: ':id/wishlist',
                component: WishlistComponent,
                title: 'WishList'
            },
            {
                path: ':id/change-password',
                component: UserChangePasswordComponent,
                title: 'Change password'
            },
            {
                path: ':id/edit',
                component: UserEditFormComponent,
                title: 'Edit User'
            },
            {
                path: ':id/upload-profile-picture',
                component: UserProfilePictureComponent,
                title: 'Update Profile Picture'
            },
            {
                path: 'shipping-addresses',
                component: ShippingAddressComponent,
                title: 'Shipping addresses'
            },
            {
                path: ':id/products',
                component: OfferComponent,
                title: 'Products',
                canActivate: [SellerProfileIncompleteGuard]
            },
            {
                path: ':id/products/add',
                component: OfferFormComponent,
                canActivate: [VerifiedSellerGuard]
            },
            {
                path: ':id/products/:productId',
                component: OfferViewComponent,
                title: 'Add Offer',
                canActivate: [SellerProfileIncompleteGuard]
            },
            {
                path: ':id/products/:productId/sales',
                component: SalesComponent,
                title: 'My Sales',
                canActivate: [SellerProfileIncompleteGuard]
            },
            {
                path: ':id/products/:productId/edit',
                component: OfferEditFormComponent,
                title: 'Edit Offer',
                canActivate: [SellerProfileIncompleteGuard]
            },
            {
                path: ':id/subscription',
                component: SubscriptionComponent,
                title: 'Subscription',
                canActivate: [VerifiedSellerGuard]
            },
            {
                path: ':id/sales',
                component: SalesListComponent,
                title: 'My Sales',
                canActivate: [VerifiedSellerGuard]
            },
            {
                path: ':id/sales/:saleId',
                component: SaleDetailComponent,
                title: 'Sale Details',
                canActivate: [VerifiedSellerGuard]
            },
            {
                path: 'billing-history',
                component: BillingHistoryComponent,
                title: 'Billing History',
                canActivate: [AuthGuard]
            },
            {path: ':id/orders', component: OrdersListComponent, title: 'My Orders'},
            {path: ':id/orders/:orderRef', component: OrderComponent, title: 'Order details'},
            {
                path: 'shipping-means',
                component: ShippingMeansComponent,
                title: 'Shipping Means',
                canActivate: [AuthGuard]
            },
            {
                path: 'shipping-means/:id',
                component: ShippingOptionDetailComponent,
                title: 'Shipping Option Details',
                canActivate: [AuthGuard]
            },
            {
                path: 'delivery-requests',
                component: DeliveryRequestsComponent,
                title: 'Delivery Requests',
                canActivate: [AuthGuard]
            },
            {
                path: 'delivery-requests/:id',
                component: DeliveryRequestDetailComponent,
                title: 'Delivery Request Detail',
                canActivate: [AuthGuard]
            },
        ]
    },
    {path: 'shopping-cart', component: CartComponent, title: 'Cart details'},
    {path: 'delivery', component: DeliveryComponent, title: 'Delivery', canActivate: [AuthGuard]},
{path: 'products/category/:slug', component: CategoryProductsComponent, title: 'Category - Products'},
    {path: 'products/seller/:userId', component: SellerProductsComponent, title: 'Seller Products'},
    {path: 'market-bag', component: MarketBagComponent, title: 'Market Bag - eFarm.cm'},
    {path: 'products/taxonomy/:taxonomy_id', component: ProductsListComponent, runGuardsAndResolvers: 'always', title: 'Taxonomy - Products'},
    {path: 'products/:slug/:id', component: SingleProductComponent, title: 'Product - details'},
    {path: 'products/:pricing', component: ProductsListComponent, runGuardsAndResolvers: 'always', title: 'Pricing - Products'},
    {path: 'checkout', component: CheckoutComponent, title: 'Checkout'},
    {path: 'marketplace', component: ProductsListComponent, title: 'Marketplace'},
    {path: 'blog/add', component: AddBlogPostComponent, canActivate: [AuthGuard], title: 'Add blog post'},
    {path: 'blog/category/:categorySlug', component: BlogComponent, title: 'Blog page'},
    {path: 'blog/:slug/:id', component: BlogPostComponent, title: 'Blog post'},
    {path: 'pages/:slug', component: PageComponent, title: 'Page'},
    {path: 'blog', component: BlogComponent, title: 'Blog page'},
    {path: 'testimonials', component: TestimonialsPageComponent, title: 'Testimonials'},
    {path: 'partners', component: PartnersPageComponent, title: 'Partners & Clients'},
    {path: 'weather', component: WeatherComponent, title: 'Weather & Climate'},
    {path: 'experts', component: ExpertsComponent, title: 'Experts Community'},
    {path: 'market-prices', component: MarketPricesComponent, title: 'Market Prices'},
    {path: 'payment/return', component: PaymentReturnComponent},
    {path: 'payment/success/:itemRef', component: PaymentSuccessComponent, canActivate: [AuthGuard]},
    {path: 'contact-us', component: ContactComponent, title: 'Contact us'},
    {path: 'career', component: CareerComponent, title: 'Opening jobs positions'},
    {path: 'meet-our-team', component: TeamComponent, title: 'Meet our team'},
    {path: 'search', component: ProductsListComponent, title: 'Products - searcch results'},
    {path: 'not-found', component: PageNotFoundComponent},
    {path: '', component: HomeNewComponent, title: 'Home'},
    {path: '', redirectTo: '/', pathMatch: 'full'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
